import Input, { BaseInputPropsType, InputPropsType } from "./Input";

type TelInputPropsType = BaseInputPropsType<HTMLInputElement, string> & {
    minLength?: number
    maxLength?: number,
}

const TelInput = (props: TelInputPropsType) => {

    const onChange = (s: string | undefined, input: React.ChangeEvent<HTMLInputElement>) => {
        let string = '';
        if(s) {
            for(let i = 0; i<s.length; i++) {
                if(i === 0 && s[i].match("[+0]")) string += s[i];
                else if(s[i].match("[0-9]")) string += s[i];
            }
            input.currentTarget.value = string;
            if(props.onChange) props.onChange(string, input);
        }
        else if(props.onChange) props.onChange(s, input);
    }

    const costumeErrors = [
        ...(props.customErrors || [])
    ]

    const telProps = {
        ...props,
        type: "tel",
        pattern: '([+]{1,1}|[0]{1,2})[0-9]+',
        onChange: onChange,
        customErrors: costumeErrors
    } as InputPropsType;

    return (
        <Input {...telProps} />
    );
};

export default TelInput;
